import { classInstance } from '@/shared/helpers/helpers';
import { CatalogFilterSection } from './catalog-filter-section/catalog-filter-section';
import { CatalogFilterRange } from './catalog-filter-range/catalog-filter-range';

export class CatalogFilter {
	private readonly element: HTMLElement | null;
	private sectionElements: NodeListOf<HTMLElement>;
	private rangeElements: NodeListOf<HTMLElement>;
	private sections: CatalogFilterSection[] = [];
	private ranges: CatalogFilterRange[] = [];

	constructor(element: HTMLElement | null) {
		this.element = element;
		this.init();
	}

	public init = (): void => {
		if (!this.element) return;

		this.rangeElements = this.element.querySelectorAll('.catalog-filter-range');
		this.sectionElements = this.element.querySelectorAll('.catalog-filter-section');

		this.sectionElements.forEach((element) => this.sections.push(new CatalogFilterSection(element)));
		this.rangeElements.forEach((element) => this.ranges.push(new CatalogFilterRange(element)));

		classInstance.set(this.element, { catalogFilter: this });
	};

	public destroy = (): void => {
		if (!this.element) return;

		classInstance.del(this.element, 'catalogFilter');
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
